<template>
    <div class="table_wrap">
        <div class="table_search row has_bc">
            <el-row>
                <el-col :span="12" >
                </el-col>
                <el-col :span="12" class="text_right">
                </el-col>
            </el-row>
        </div>
        <el-table
                :data="orderData"
                style="width: 100%"
                empty-text="데이터가 없습니다."
                @selection-change="tableSelectChange"

        >
            <el-table-column
                    class="table_no"
                    type="index"
                    label="No"
                    width="80"
                    class-name="num text-center"
                    :index="tableIdx"
            >
            </el-table-column>
            <el-table-column label="아이디" prop="mb_id" class-name="text-center"></el-table-column>
            <el-table-column label="닉네임" prop="mb_nick" class-name="text-center"></el-table-column>
            <el-table-column
                    label="상태" width="150" class-name="text-center">
                <template slot-scope="scope">
                    <span>
                        {{orderStatusName(scope.row.o_status)}}
                    </span>
                </template>
            </el-table-column>
            <el-table-column label="상품명" prop="i_name" class-name="text-center"></el-table-column>
            <el-table-column
                    label="금액" width="150" class-name="text-center">
                <template slot-scope="scope">
                        <span>
                            ${{scope.row.o_price}}
                        </span>
                </template>
            </el-table-column>
            <el-table-column label="결제번호" prop="o_id" class-name="text-center"></el-table-column>
            <el-table-column
                    label="일시" width="150" class-name="text-center">
                <template slot-scope="scope">
                    <span>
                        {{returnDate(scope.row.created_at)}}
                    </span>
                </template>
            </el-table-column>
        </el-table>
    </div>

</template>

<script>
    import {mapState, mapGetters} from "vuex";
    import util from "@/mixins/util";
    import {loginType} from "@/service/MemberService";
    import {orderStatus} from "@/service/orderService";

    export default {
        name: "MemberListDefaultLayout",
        mixins: [],
        components: {
        },
        props: {
            orderData: {
                type: Array,
                default: () => {return []},
            },
            paginationData: {
                type: Object,
                default: {
                    total: 0,
                    page: 0,
                    size: 0,
                }
            },
            setData: {
                type: Function,
                default: () => {}
            }
        },
        data() {
            return {
                selectArr: []
            }
        },
        beforeRouterEnter() {},
        created() {
        },
        mounted() {

        },
        beforeDestroy() {
        },
        destroyed() {},
        computed: {
            ...mapState({
                countries: state => state.country.countries
            })
        },
        methods:{
            goDetail(no) {
                let nowPath = this.$route.path;
                this.$router.push(`${nowPath}/${no}`);
            },
            tableIdx(index) {
                return this.paginationData.total - index - (this.paginationData.page - 1) * this.paginationData.size;
            },
            tableSelectChange(row) {
                this.selectArr = row;
                this.setData('selectArr', this.selectArr)
            },
            returnDate(date=null) {
                if(!date) {
                    return '';
                }
                return this.$moment.unix(date).format('YYYY-MM-DD HH:mm')
            },
            loginTypeName(type) {
                if(util.isEmpty(type) || util.isEmpty(loginType[type])) {
                    return '이메일계정'
                }
                return loginType[type];
            },
            orderStatusName(type) {
                if(util.isEmpty(type) || util.isEmpty(orderStatus[type])) {
                    return ''
                }
                return orderStatus[type];
            },

        },
        watch: {

        },
    }
</script>

<style scoped>

</style>